import { Brand } from "./Brand";
import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../features/auth/AuthProvider";

const NAV = [
  { to: "/securities", label: "Titres" },
  { to: "/sgis", label: "SGI" },
  { to: "/prices", label: "Cours" },
  { to: "/import", label: "Import CSV" },
  { to: "/opportunities", label: "Opportunités" },
  { to: "/prospects", label: "Prospects" },
  { to: "/clients", label: "Clients" },
  { to: "/security", label: "Sécurité (2FA)" },
];

export function Layout() {
  const { user, logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setDrawerOpen(false), [pathname]);

  return (
    <div className="app-shell">
      <header className="mobile-topbar">
        <button
          type="button"
          className="hamburger"
          aria-label="Ouvrir le menu"
          aria-expanded={drawerOpen}
          onClick={() => setDrawerOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
        <Brand suffix="Admin" />
      </header>

      {drawerOpen && <div className="sidebar-backdrop" onClick={() => setDrawerOpen(false)} />}

      <aside className={`sidebar ${drawerOpen ? "sidebar-open" : ""}`}>
        <Brand suffix="Admin" className="sidebar-brand" />
        <nav>
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => (isActive ? "active" : "")}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">
          <span title={user?.email}>{user?.email}</span>
          <button className="btn btn-ghost" onClick={logout}>
            Déconnexion
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
